import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type SwitchVertical01IconProps = IconProps

const SwitchVertical01Icon = forwardRef<
  SVGSVGElement,
  SwitchVertical01IconProps
>((props: SwitchVertical01IconProps, ref) => (
  <Icon {...props} ref={ref}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M17 4v16m0 0-4-4m4 4 4-4M7 20V4m0 0L3 8m4-4 4 4"
      fill="none"
    ></path>
  </Icon>
))

SwitchVertical01Icon.displayName = 'SwitchVertical01Icon'
SwitchVertical01Icon.defaultProps = iconDefaultProps

export type { SwitchVertical01IconProps }
export { SwitchVertical01Icon }
